import React from 'react';
import { TrendingDown, Zap, Euro, Gauge } from 'lucide-react';

const stats = [
  { label: 'Druckluftverlust', value: '30%', unit: 'in Industrieanlagen', icon: TrendingDown, color: '#ff2a55' },
  { label: 'Erzeugungskosten', value: '0,02', unit: '€ pro m³ Druckluft', icon: Euro, color: '#0891b2' },
  { label: 'Energieanteil', value: '10%', unit: 'des Industrie-Strombedarfs', icon: Zap, color: '#0891b2' },
  { label: 'Detektion', value: '20–100', unit: 'kHz Ultraschallbereich', icon: Gauge, color: '#00ff66' },
];

export default function Statistics() {
  return (
    <section className="relative py-16 sm:py-24 md:py-32 border-y border-slate-200/70" data-testid="statistics-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-6 md:px-12">
        <div className="grid lg:grid-cols-12 gap-12 mb-16">
          <div className="lg:col-span-5">
            <div className="eyebrow mb-5">Das Problem</div>
            <h2 className="font-display font-black text-slate-900 text-3xl sm:text-4xl md:text-5xl tracking-tighter leading-[1.02]">
              Unsichtbare Lecks. Sichtbare Kosten.
            </h2>
          </div>
          <div className="lg:col-span-6 lg:col-start-7">
            <p className="text-slate-600 text-base sm:text-lg leading-relaxed">
              In typischen Druckluftnetzen entweichen 20–35&nbsp;% der erzeugten Luft durch
              kleinste Leckagen — oft über Jahre unbemerkt. Ein einziges 3-mm-Leck bei 6&nbsp;bar
              verursacht rund 4.000&nbsp;€ Energiekosten pro Jahr. Druckluft ist mit Erzeugungskosten
              von ca. 0,02&nbsp;€/m³ die teuerste Energieform in der Fertigung; bis zu 10&nbsp;% des
              Industrie-Strombedarfs gehen in Kompressoren.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
          {stats.map((s, i) => {
            const Icon = s.icon;
            return (
              <div
                key={s.label}
                className="card-surface p-5 sm:p-7 group"
                data-testid={`stat-card-${i}`}
              >
                <div className="flex items-start justify-between mb-8">
                  <div
                    className="w-10 h-10 grid place-items-center border"
                    style={{ borderColor: `${s.color}40` }}
                  >
                    <Icon className="w-5 h-5" style={{ color: s.color }} />
                  </div>
                  <div className="font-mono-tech text-[10px] uppercase tracking-[0.2em] text-slate-400">
                    {String(i + 1).padStart(2, '0')} / 04
                  </div>
                </div>
                <div className="font-mono-tech text-[10px] uppercase tracking-[0.2em] text-slate-500 mb-2">
                  {s.label}
                </div>
                <div className="font-display font-black text-slate-900 text-5xl tracking-tighter mb-1" style={{ color: s.color }}>
                  {s.value}
                </div>
                <div className="text-slate-500 text-sm">{s.unit}</div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
